module.exports = __webpack_public_path__ + "static/media/addPhoto.3a67cb07.svg";